import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Import Layout
import Layout from './pages/shared/Layout/Layout';

// Import pages
import Home from './pages/Home/Home';
import About from './pages/About/About';
import ListProperty from './pages/ListProperty/ListProperty';
import Contact from './pages/Contact/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';

// Import LoadingScreen
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

// Scroll to top on route change
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    // Start fade-out at 4.5 seconds
    const fadeOutTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, 4500);

    // Remove component at 5 seconds
    const removeTimer = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5 seconds

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  return (
    <>
      {isLoading && <LoadingScreen isFadingOut={isFadingOut} />}
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="list-property" element={<ListProperty />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
